'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _busSchemaHtml = require('./bus-schema.html');

var _busSchemaHtml2 = _interopRequireDefault(_busSchemaHtml);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function Directive($timeout, $state, Auth, UserComponent) {
	'ngInject';

	var directive = {
		link: link,
		template: _busSchemaHtml2['default'],
		'restrict': 'E',
		'scope': {
			'seatsCount': '&',
			'seats': '=',
			'unavailableSeats': '&',
			'clickHandler': '=',
			'loadSeats': '=',
			'direction': '@',
			'travelDirection': '@',
			'withUsers': '='
		}
	};

	return directive;

	function link(scope) {
		scope.currentUser = Auth.getCurrentUser().roles ? Auth.getCurrentUser().roles[0].name : 'client';
		scope.hiddenSeat = hiddenSeat;
		scope.seatsInRow = 4;
		scope.loadSeats = function () {
			// Timeout is needed because of digest bug in the controllers
			$timeout(function () {
				loadSeats();
			});
		};
		if (scope.withUsers) {
			scope.userNames = userNames;
			UserComponent.fetchUsers().then(function (data) {
				scope.users = data;
			});
		}

		loadSeats();

		/** */
		function userNames(id) {
			if (scope.users && id) {
				for (var i = 0, k = scope.users.length; i < k; i++) {
					if (scope.users[i].user[0].id === id) {
						return scope.users[i].name || scope.users[i].names;
					}
				}
			}
		}
		/** */
		function hiddenSeat(status) {
			if (status === 'locked') {
				if ($state.current.name === 'app.public.btms.choose-seat' || scope.currentUser === 'agent') {
					return true;
				}
			} else {
				return false;
			}
		}

		function loadSeats() {
			scope.rows = new Array(Math.ceil(scope.seatsCount() / scope.seatsInRow));

			// Fill the last row of the bus with gaps when it is not full with seats
			var updatedSeatsCount = scope.seatsCount();
			while (updatedSeatsCount % 4 !== 0) {
				updatedSeatsCount++;
			}

			scope.seats = [];
			var foundSeat = undefined;

			for (var i = 0; i < updatedSeatsCount; i++) {
				foundSeat = _lodash2['default'].find(scope.unavailableSeats(), { 'number': i + 1 });

				if (foundSeat) {
					scope.seats.push({
						'active': true,
						'color': foundSeat.color || foundSeat.status || foundSeat.ticket.status,
						'id': foundSeat.id,
						'user_id': foundSeat.user_id,
						'number': foundSeat.number,
						'status': foundSeat.status || foundSeat.ticket.status
					});
				} else {
					scope.seats.push({
						'active': false,
						'number': i + 1,
						'status': 'free'
					});
				}
			}
		}
	}
}

exports['default'] = Directive;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/bus-schema/bus-schema.directive.js
 **/